import {
  CATEGORIES,
  LABELS,
  ACTIONS,
  EVENTS
} from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';

export const sendViewEvent = () => {
  GtagService.sendEvent({
    event: EVENTS.NO_INTERACTION,
    category: CATEGORIES.CLUB_ADMIN_SCHEDULE,
    action: ACTIONS.SHOW,
    where: ACTIONS.SCHEDULE.BANNER_RESEND_ACCESS
  });
};

export const sendConfirmEvent = () => {
  GtagService.sendEvent({
    event: EVENTS.INTERACTION,
    category: CATEGORIES.CLUB_ADMIN_SCHEDULE,
    action: ACTIONS.CLICK,
    where: ACTIONS.SCHEDULE.BANNER_RESEND_ACCESS,
    label: LABELS.SEND_NOW
  });
};

export const sendCancelEvent = () => {
  GtagService.sendEvent({
    event: EVENTS.INTERACTION,
    category: CATEGORIES.CLUB_ADMIN_SCHEDULE,
    action: ACTIONS.CLICK,
    where: ACTIONS.SCHEDULE.BANNER_RESEND_ACCESS,
    label: LABELS.SEND_LATER
  });
};
